'use strict';

import $ from 'jquery';

export default ["$window", "$timeout", function($window, $timeout) {
    return {
        restrict: 'A',
        scope: {},
        require: '^ngModel',
        priority: 10, //needs this to overwrite the ngModel.$render method of the built-in select directive
        link: function (scope, element, attrs, ngModel) {

            //Overwrite ngModel render method
            ngModel.$render = function () {
                //if this is not in a $timeout then programmatically setting the last item in a select list doesn't work. Don't ask.
                $timeout(function () {
                    element.val(ngModel.$viewValue);
                    element.triggerHandler('change');
                }, 0);
            };

            element.on('select2:unselecting',
                function (e) {
                    element.val('');
                    element.triggerHandler('change');
                    e.preventDefault();
                });

            $(element).on("change", function () {
                element.triggerHandler('change');
            });
        }
    }
}];